import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Navbar from "../../../../posnavbar/Navbar";
import React from "react";
import "./MenuCategory.css";
import { useNavigate } from "react-router-dom";

const columns = [
  { field: "category", headerName: "Category", flex: 1 },
  { field: "subCategory", headerName: "Sub Category", flex: 1 },
];

const rows = [
  { id: 1, category: "Biriyani", subCategory: "Hyderabadi" },
  { id: 2, category: "North Indian", subCategory: "Gravies" },
  { id: 3, category: "South Indian", subCategory: "Non-Veg" },
  { id: 4, category: "Rice", subCategory: "Veg" },
];

export const MenuCategoryTable = () => {
  const navigate = useNavigate();
  return (
    <Navbar>
      <Box py={8} sx={{ width: "100%" }}>
        <Box
          className="categoryMenuGrid"
          sx={{ display: "flex", flexDirection: "column", gap: "5px" }}
        >
          <Button
            sx={{
              background:
                "linear-gradient(108.12deg, #5271FF 7.04%, #33469F 72.53%, #314499 96.99%)",
              color: "#FFFFFF",
              border: "0.5px solid #BEBEBE",
              alignSelf: "flex-end",
            }}
            onClick={() => navigate("/settings/create-category")}
          >
            Add Category
          </Button>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            disableSelectionOnClick
            disableColumnMenu
            autoHeight
            pagination={false}
            hideFooter={true}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                background: "#F3F3F3",
              },
            }}
          />
        </Box>
      </Box>
    </Navbar>
  );
};
